













import {Component, Vue, Prop} from 'vue-property-decorator';
import Chips from '@/components/controls/Chips.vue';
import {DiagramData} from '@/interfaces/diagrams';
import Loading from '@c/controls/Loading.vue';
import AngleDiagram from './AngleDiagram.vue';
import {AngleDiagramData} from './interfaces';
import {addAngleSubscription} from '@/utils/socketUtils';
import {getApiStoreSpectrum} from './utils';

const getDiagramSubscriptionParams = (diagram: AngleDiagramData, measurement: any) => ({
  moduleType: diagram.moduleType,
  moduleGUID: diagram.moduleGUID,
  alias: measurement.alias,
  eventType: measurement.eventType,
});

@Component({
  components: {
    AngleDiagram,
    Chips,
    Loading,
  },
})
export default class AngleDiagramBox extends Vue {
  chartDataX: DiagramData = {
    data: [
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
    ],
    yAxis: {name: '', units: ''},
    name: '',
    id: null,
    visible: true,
  };

  chartDataY: DiagramData = {
    data: [
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
    ],
    yAxis: {name: '', units: ''},
    name: '',
    id: null,
    visible: true,
  };

  chartDataZ: DiagramData = {
    data: [
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
      {angle: 0, amplitude: 0},
    ],
    yAxis: {name: '', units: ''},
    name: '',
    id: null,
    visible: true,
  };

  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;

  // Диаграмма
  @Prop({required: true})
  diagram!: AngleDiagramData;

  async created() {
    await this.defineInitialChartState();
  }

  // Метод установки начального состояния графика
  async defineInitialChartState() {
    try {
      this.loading = true;
      this.error = false;

      const result = await getApiStoreSpectrum(this.diagram.moduleType).getLastEvents({
        id: this.diagram.moduleId,
        eventType: 'phase-angle-changed',
        limit: 1,
      });

      this.setData(result);

      this.diagram.measurements.forEach((measurement: any) => {
        this.addWSSubscriptions(measurement);
      });
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  setDataX(data: any) {
    this.chartDataX = data;
    (this.$refs.diagramX as any).setValues();
  }
  setDataY(data: any) {
    this.chartDataY = data;
    (this.$refs.diagramY as any).setValues();
  }
  setDataZ(data: any) {
    this.chartDataZ = data;
    (this.$refs.diagramZ as any).setValues();
  }

  setData(data: any) {
    this.chartDataX = {
      data: [
        {angle: data[0][0][1], amplitude: data[0][0][4]},
        {angle: data[0][0][7], amplitude: data[0][0][10]},
        {angle: data[0][0][13], amplitude: data[0][0][16]},
      ],
      yAxis: {name: '', units: ''},
      name: 'Оборотная для оси X',
      id: null,
      visible: true,
    };

    this.chartDataY = {
      data: [
        {angle: data[0][0][2], amplitude: data[0][0][5]},
        {angle: data[0][0][8], amplitude: data[0][0][11]},
        {angle: data[0][0][14], amplitude: data[0][0][17]},
      ],
      yAxis: {name: '', units: ''},
      name: 'Оборотная для оси Y',
      id: null,
      visible: true,
    };

    this.chartDataZ = {
      data: [
        {angle: data[0][0][3], amplitude: data[0][0][6]},
        {angle: data[0][0][9], amplitude: data[0][0][12]},
        {angle: data[0][0][15], amplitude: data[0][0][18]},
      ],
      yAxis: {name: '', units: ''},
      name: 'Оборотная для оси Z',
      id: null,
      visible: true,
    };
  }

  addWSSubscriptions(measurement: any) {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    if (!this.$dataSocketManager.hasSubscription(measurement.id)) {
      const params = getDiagramSubscriptionParams(this.diagram, measurement);
      const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
      const subscriptionFunction = (socket: WebSocket) =>
        addAngleSubscription.call(this, socket, params);

      this.$dataSocketManager.addSubscription(
        measurement.id,
        subscrName,
        subscriptionFunction,
        this.subscribeConectionWS.bind(this),
      );
    }
  }

  async subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    if (!strParse) return;

    const data = strParse;

    try {
      this.error = false;

      switch (data.module_alias) {
        case 'angle_05_x':
          this.chartDataX.data[0].angle = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'angle_05_y':
          this.chartDataY.data[0].angle = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'angle_05_z':
          this.chartDataZ.data[0].angle = data.value;
          this.setDataZ(this.chartDataZ);
          break;
        case 'angle_1_x':
          this.chartDataX.data[1].angle = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'angle_1_y':
          this.chartDataY.data[1].angle = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'angle_1_z':
          this.chartDataZ.data[1].angle = data.value;
          this.setDataZ(this.chartDataZ);
          break;
        case 'angle_2_x':
          this.chartDataX.data[2].angle = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'angle_2_y':
          this.chartDataY.data[2].angle = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'angle_2_z':
          this.chartDataZ.data[2].angle = data.value;
          this.setDataZ(this.chartDataZ);
          break;
        case 'amplitude_05_x':
          this.chartDataX.data[0].amplitude = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'amplitude_05_y':
          this.chartDataY.data[0].amplitude = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'amplitude_05_z':
          this.chartDataZ.data[0].amplitude = data.value;
          this.setDataZ(this.chartDataZ);
          break;
        case 'amplitude_1_x':
          this.chartDataX.data[1].amplitude = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'amplitude_1_y':
          this.chartDataY.data[1].amplitude = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'amplitude_1_z':
          this.chartDataZ.data[1].amplitude = data.value;
          this.setDataZ(this.chartDataZ);
          break;
        case 'amplitude_2_x':
          this.chartDataX.data[2].amplitude = data.value;
          this.setDataX(this.chartDataX);
          break;
        case 'amplitude_2_y':
          this.chartDataY.data[2].amplitude = data.value;
          this.setDataY(this.chartDataY);
          break;
        case 'amplitude_2_z':
          this.chartDataZ.data[2].amplitude = data.value;
          this.setDataZ(this.chartDataZ);
          break;
      }
    } catch {
      this.error = true;
    }
  }

  beforeDestroy() {
    this.removeWSSubscriptions();
  }

  removeWSSubscriptions() {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    this.diagram.measurements.forEach((measurement: any) => {
      this.addWSSubscriptions(measurement.id);
    });
  }
}
